import { company_name } from "@/i18n/variables";

const entities = {
	backups: {
		default: "Standaard back-ups",
		extra: "Extra back-ups",
		title: "Back-ups",
	},
	cpu: {
		assigned: "Toegewezen",
		title: "CPU",
		usage: "In gebruik",
	},
	extra_storage: {
		bulk: {
			title: "Bulk Opslag (HDD)",
		},
		default: {
			title: "Opslag (SSD)",
		},
	},
	ip_config: {
		ipv4: "IPv4-adres",
		ipv6: "IPv6-adres",
		title: "IP-adressen",
	},
	login: {
		info: "Het onderstaande wachtwoord is het wachtwoord dat bij de oplevering van de VPS is ingesteld. Bewaar het goed, aangezien het alleen getoond wordt gedurende <strong>31 dagen</strong> na de oplevering.",
		password: {
			expired: "Verlopen",
			expired_tooltip: `Het VPS-wachtwoord dat bij de oplevering is ingesteld wordt hier alleen de eerste <strong>31 dagen</strong> na de oplevering getoond, om desinformatie te voorkomen. Als u uw wachtwoord niet heeft opgeslagen, kunt u contact op nemen met ${company_name}.`,
			title: "Wachtwoord",
			tooltip:
				"Dit is het wachtwoord dat bij de oplevering van de VPS is ingesteld. Bewaar het goed, aangezien het alleen getoond wordt gedurende <strong>31 dagen</strong> na de oplevering.",
		},
		title: "Inloggegevens",
		username: "Gebruikersnaam",
	},
	memory: {
		assigned: "Toegewezen",
		title: "Werkgeheugen",
		usage: "In gebruik",
	},
	nameservers: {
		ns1_ipv4: "Nameserver 1 (IPv4)",
		ns1_ipv6: "Nameserver 1 (IPv6)",
		ns1_nat64: "Nameserver 1 (Nat64)",
		ns2_ipv4: "Nameserver 2 (IPv4)",
		ns2_ipv6: "Nameserver 2 (IPv6)",
		title: "Nameservers",
	},
	private_network: {
		title: "Private network",
	},
	server_location: {
		title: "Server locatie",
	},
	sla: {
		sla_level: {
			level_0: "Level 0",
			level_1: "Level 1",
			level_2: "Level 2",
			none: "Geen SLA",
		},
		title: "SLA",
	},
	snapshots: {
		title: "Snapshots",
	},
	storage: {
		title: "Opslag (SSD)",
	},
};

export default entities;
